import React from "react";

import './index.css'
import LogoGregg from './Logo_Gregg.svg';
import Routes from "./components/client/Routes";

const App = () => 
  <div className="center">
    <div className="content">
      <div className="text-center">
        <img className="gregg-logo" src={LogoGregg} width="100"/> 
      </div>
      <Routes /> 
    </div>
  </div>;

export default App;



// WEBPACK FOOTER //
// ./src/App.js